module.exports = __webpack_public_path__ + "img/twitter.8e87d9c0.svg";